/* eslint-disable */
import React from "react";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { SLIDE_NUMBER, BUSINESS_UNIT } from "../constants";
import { orderBy } from "lodash";

interface ControlItem extends HierarchyControlItem<number> {
  olapId: number;
}

export const CropsControl: React.FC = () => {
  const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);
  const [loadingValue, setLoadingValue] = React.useState<boolean>(true);
  const [commodityDisplay, setCommodityDisplay] = useParameter<number | null>("@commodities_display");
  const [commodityValue, setCommodityValue] = useParameter<number | null>("@commodities");

  const [dictItems, dict, dictLoading] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    business_unit: BUSINESS_UNIT,
    slide: SLIDE_NUMBER,
  });

  React.useEffect(
    function updateControlItems() {
      setLoadingValue(true);
      if (dictItems) {
        const sortedDictItems = orderBy(dictItems, (item) => item.getValue<number>("order"));
        const nextControlItems = sortedDictItems.map<ControlItem>((dictItem) => ({
          id: dictItem.getValue<number>('id')!,
          name: dictItem.getValue<Record<number, string>>("name")![9],
          parent: dictItem.getValue<number>("parent"),
          olapId: dictItem.getValue<number>('olap_commodity')!,
          disabled: dictItems.some((x) => x.getValue<number>("parent")?.toString() === dictItem.id),
        }));
        setControlItems(nextControlItems);

        const selectedCandidate = nextControlItems.find(e => e.olapId === commodityValue);
        if (selectedCandidate) {
          if (selectedCandidate.id !== commodityDisplay) {
            setCommodityDisplay(selectedCandidate.id);
          }
        } else {
          setCommodityDisplay(nextControlItems[0]?.id);
        }
        setLoadingValue(false);
      }
    },
    [dictItems],
  );

  const handlerChange = React.useCallback(
    (value: number | undefined) => {
      if (value) {
        const selectedItem = controlItems.find((item) => item.id === value)!;
        setCommodityDisplay(value);
        setCommodityValue(selectedItem.olapId);
      }
    },
    [controlItems],
  );

  const loading = loadingValue || dictLoading;

  return <HierarchyControl
    loading={loading}
    label="Crops"
    value={commodityDisplay as number | undefined}
    onChange={handlerChange}
    items={controlItems}
  />
};
